import { render, staticRenderFns } from "./deliveryreport.vue?vue&type=template&id=e71a9038&scoped=true&"
import script from "./deliveryreport.vue?vue&type=script&lang=js&"
export * from "./deliveryreport.vue?vue&type=script&lang=js&"
import style0 from "./deliveryreport.vue?vue&type=style&index=0&id=e71a9038&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71a9038",
  null
  
)

export default component.exports